import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Image from "react-bootstrap/Image";
import { connect } from "react-redux";
import {
  snapShotEditArticleMetaAction,
  recoverLastEditArticleMetaAction,
  updateArticleMetaTextAction,
  updateArticleMetaContributorNamesAction,
  setLockingIDAction,
  setACDItemAction,
  pushContributorNameAction,
  deleteContributorNameAction,
  saveArticleAction
} from "../../redux/actions/editArticlePanel";
import "./EditArticleMetaList.css";
import { ACDTYPE_TEXT_ONLY, ACDTYPE_IMAGE_ONLY } from "../../model/ACDTypes";

import {
  ACSTYPE_TITLE,
  ACSTYPE_SUBTITLE,
  ACSTYPE_CONTRIBUTOR,
  ACSTYPE_INTRO,
  ACSTYPE_MAIN_IMG
} from "../../model/ACSTypes";
import HoverInsertText from "../HoverInsertText/HoverInsertText";

class EditArticleMetaList extends React.Component {
  constructor(props) {
    super(props);
    this.lockClicked = this.lockClicked.bind(this);
    this.deleteClicked = this.deleteClicked.bind(this);
    this.onTitleChange = this.onTitleChange.bind(this);
    this.onSubtitleChange = this.onSubtitleChange.bind(this);
    this.onIntroChange = this.onIntroChange.bind(this);
    this.onContributorChange = this.onContributorChange.bind(this);
    this.onNameChange = this.onNameChange.bind(this);
    this.focus = this.focus.bind(this);
    this.blur = this.blur.bind(this);
    this.scrollToBottom = this.scrollToBottom.bind(this);
    this.handlePushName = this.handlePushName.bind(this);
    this.handleDelName = this.handleDelName.bind(this);

    this.titleRef = React.createRef();
    this.subtitleRef = React.createRef();

    this.headerStyle = { paddingTop: "5px", paddingBottom: "5px" };
    this.bodyStyle = { paddingTop: "10px", paddingBottom: "10px" };
  }

  componentDidUpdate(prevProps) {
    const { metaDict, articleID } = this.props;

    const titleID = articleID + "-TITLE";
    const subtitleID = articleID + "-SUBTITLE";

    if (metaDict == null || prevProps.metaDict == null) {
      return;
    }

    if (metaDict[titleID] !== prevProps.metaDict[titleID]) {
      this.scrollToBottom(this.titleRef);
    }

    if (metaDict[subtitleID] !== prevProps.metaDict[subtitleID]) {
      this.scrollToBottom(this.subtitleRef);
    }
  }

  handleDelName(idx, arrayIdx) {
    const {
      articleID,
      deleteContributorNameAction,
      saveArticleAction
    } = this.props;
    const id = articleID + "-CONTRIBUTOR";

    deleteContributorNameAction({
      id,
      index: idx,
      arrayIdx: arrayIdx
    });
    saveArticleAction(articleID);
  }

  handlePushName(idx) {
    const {
      articleID,
      pushContributorNameAction,
      saveArticleAction
    } = this.props;
    const id = articleID + "-CONTRIBUTOR";
    pushContributorNameAction({
      id,
      index: idx
    });
    saveArticleAction(articleID);
  }

  deleteClicked(id) {
    const {
      articleID,
      setACDItemAction,
      saveArticleAction,
      metaDict
    } = this.props;
    const dataID = articleID + "-" + id;

    let acsType = "";

    switch (id) {
      case "TITLE":
        acsType = ACSTYPE_TITLE;
        break;
      case "SUBTITLE":
        acsType = ACSTYPE_SUBTITLE;
        break;
      case "CONTRIBUTOR":
        acsType = ACSTYPE_CONTRIBUTOR;
        break;
      case "INTRO":
        acsType = ACSTYPE_INTRO;
        break;
      case "MAIN_IMG":
        acsType = ACSTYPE_MAIN_IMG;
        break;
      default:
        acsType = "";
    }

    let anACDItem =
      id === "MAIN_IMG"
        ? {
            id: dataID,
            text: "",
            image: null,
            isTextServerProcessed: true,
            textLineIDs: null,
            dataType: ACDTYPE_IMAGE_ONLY,
            styleType: acsType,
            names: null
          }
        : {
            id: dataID,
            text: "",
            image: null,
            isTextServerProcessed: true,
            textLineIDs: null,
            dataType: ACDTYPE_TEXT_ONLY,
            styleType: acsType,
            names: null
          };

    if (id === "CONTRIBUTOR") {
      anACDItem.names = metaDict[dataID].names;
    }

    setACDItemAction({
      mode: "meta",
      id: dataID,
      item: anACDItem
    });
    saveArticleAction(articleID);
  }

  lockClicked(id) {
    const { lockingID, setLockingIDAction, articleID } = this.props;
    const dataID = articleID + "-" + id;

    if (dataID === lockingID) {
      setLockingIDAction({ lockingID: null });
    } else {
      setLockingIDAction({ lockingID: dataID });
    }
  }

  onTitleChange(event) {
    const {
      articleID,
      updateArticleMetaTextAction,
      saveArticleAction
    } = this.props;
    const titleID = articleID + "-TITLE";
    updateArticleMetaTextAction({ id: titleID, text: event.target.value });
    saveArticleAction(articleID);
  }

  onSubtitleChange(event) {
    const {
      articleID,
      updateArticleMetaTextAction,
      saveArticleAction
    } = this.props;
    const id = articleID + "-SUBTITLE";
    updateArticleMetaTextAction({ id, text: event.target.value });
    saveArticleAction(articleID);
  }

  onIntroChange(event) {
    const {
      articleID,
      updateArticleMetaTextAction,
      saveArticleAction
    } = this.props;
    const id = articleID + "-INTRO";
    const newValue = event.target.value.replace(/\n/g, "");

    updateArticleMetaTextAction({ id, text: newValue });
    saveArticleAction(articleID);
  }

  onContributorChange(event) {
    const {
      articleID,
      updateArticleMetaTextAction,
      saveArticleAction
    } = this.props;
    const id = articleID + "-CONTRIBUTOR";
    updateArticleMetaTextAction({ id, text: event.target.value });
    saveArticleAction(articleID);
  }

  onNameChange(idx, isType, arrayIdx, value) {
    const {
      articleID,
      updateArticleMetaContributorNamesAction,
      saveArticleAction
    } = this.props;
    const id = articleID + "-CONTRIBUTOR";

    const typeOrName = isType ? "type" : "name";

    updateArticleMetaContributorNamesAction({
      id,
      typeOrName,
      text: value,
      index: idx,
      arrayIdx: arrayIdx
    });
    saveArticleAction(articleID);
  }

  scrollToBottom(ref) {
    if (ref != null) {
      ref.scrollLeft = ref.scrollWidth;
    }
  }

  focus() {
    const { articleID, metaDict, snapShotEditArticleMetaAction } = this.props;

    const titleID = articleID + "-TITLE";
    const subtitleID = articleID + "-SUBTITLE";
    const contributorID = articleID + "-CONTRIBUTOR";
    const introID = articleID + "-INTRO";

    this.title = metaDict[titleID].text;
    this.subtitle = metaDict[subtitleID].text;
    this.contributor = metaDict[contributorID].text;
    this.intro = metaDict[introID].text;

    snapShotEditArticleMetaAction();
  }

  blur() {
    const {
      articleID,
      metaDict,
      recoverLastEditArticleMetaAction
    } = this.props;

    const titleID = articleID + "-TITLE";
    const subtitleID = articleID + "-SUBTITLE";
    const contributorID = articleID + "-CONTRIBUTOR";
    const introID = articleID + "-INTRO";

    if (
      this.title === metaDict[titleID].text &&
      this.subtitle === metaDict[subtitleID].text &&
      this.contributor === metaDict[contributorID].text &&
      this.intro === metaDict[introID].text
    ) {
      recoverLastEditArticleMetaAction();
    }

    this.title = null;
    this.subtitle = null;
    this.contributor = null;
    this.intro = null;
    this.type0 = null;
    this.name0 = null;
    this.type1 = null;
    this.name1 = null;
    this.type2 = null;
    this.name2 = null;
  }

  render() {
    const { articleID, lockingID, metaDict } = this.props;

    if (metaDict == null) {
      return null;
    }

    const titleID = articleID + "-TITLE";
    const subtitleID = articleID + "-SUBTITLE";
    const contributorID = articleID + "-CONTRIBUTOR";
    const introID = articleID + "-INTRO";
    const mainImgID = articleID + "-MAIN_IMG";

    const title = metaDict[titleID] == null ? "" : metaDict[titleID].text;
    const subtitle =
      metaDict[subtitleID] == null ? "" : metaDict[subtitleID].text;
    const contributor =
      metaDict[contributorID] == null ? "" : metaDict[contributorID].text;
    const intro =
      metaDict[introID] == null
        ? ""
        : metaDict[introID].text.replace(/\n/g, "");

    let thumbID = null;
    try {
      thumbID = metaDict[mainImgID].image.id;
    } catch (e) {
      thumbID = null;
    }

    const mainImgUri =
      thumbID == null
        ? ""
        : `${
            process.env.REACT_APP_API_ROOT
          }artworks/${thumbID}/static/thumbnail`;

    return (
      <div className="no_move_panel">
        <Card
          text="dark"
          bg={lockingID === titleID ? "warning" : null}
          className="toc_list_card"
        >
          <Card.Header style={this.headerStyle}>
            <span className="toc_order_number">Title</span>
            <Button
              variant={lockingID === titleID ? "primary" : "secondary"}
              size="sm"
              className="toc_delete_btn"
              onClick={() => this.lockClicked("TITLE")}
            >
              <span className="fa fa-lock" />
            </Button>
            <Button
              variant="danger"
              size="sm"
              className="toc_delete_btn"
              onClick={() => this.deleteClicked("TITLE")}
            >
              <span className="fa fa-eraser" />
            </Button>
          </Card.Header>
          <Card.Body style={this.bodyStyle}>
            <Row>
              <Col>
                <Form.Control
                  size="sm"
                  type="text"
                  placeholder="Title"
                  value={title}
                  onChange={this.onTitleChange}
                  onFocus={this.focus}
                  //onBlur={this.blur}
                  ref={el => (this.titleRef = el)}
                />
              </Col>
            </Row>
          </Card.Body>
        </Card>

        <Card
          text="dark"
          bg={lockingID === subtitleID ? "warning" : null}
          className="toc_list_card"
        >
          <Card.Header style={this.headerStyle}>
            <span className="toc_order_number">Subtitle</span>
            <Button
              variant={lockingID === subtitleID ? "primary" : "secondary"}
              size="sm"
              className="toc_delete_btn"
              onClick={() => this.lockClicked("SUBTITLE")}
            >
              <span className="fa fa-lock" />
            </Button>
            <Button
              variant="danger"
              size="sm"
              className="toc_delete_btn"
              onClick={() => this.deleteClicked("SUBTITLE")}
            >
              <span className="fa fa-eraser" />
            </Button>
          </Card.Header>
          <Card.Body style={this.bodyStyle}>
            <Row>
              <Col>
                <Form.Control
                  size="sm"
                  type="text"
                  placeholder="Subtitle"
                  value={subtitle}
                  onChange={this.onSubtitleChange}
                  onFocus={this.focus}
                  //onBlur={this.blur}
                  ref={el => (this.subtitleRef = el)}
                />
              </Col>
            </Row>
          </Card.Body>
        </Card>

        <Card
          text="dark"
          bg={lockingID === contributorID ? "warning" : null}
          className="toc_list_card"
        >
          <Card.Header style={this.headerStyle}>
            <span className="toc_order_number">Contributor</span>
            <Button
              variant={lockingID === contributorID ? "primary" : "secondary"}
              size="sm"
              className="toc_delete_btn"
              onClick={() => this.lockClicked("CONTRIBUTOR")}
            >
              <span className="fa fa-lock" />
            </Button>
            <Button
              variant="danger"
              size="sm"
              className="toc_delete_btn"
              onClick={() => this.deleteClicked("CONTRIBUTOR")}
            >
              <span className="fa fa-eraser" />
            </Button>
          </Card.Header>
          <Card.Body style={this.bodyStyle}>
            <Row>
              <Col>
                <HoverInsertText
                  as="textarea"
                  size="sm"
                  type="text"
                  hidehtml="true"
                  placeholder="Contributors"
                  onFocus={this.focus}
                  //onBlur={this.blur}
                  value={contributor}
                  onChange={this.onContributorChange}
                />
              </Col>
            </Row>
          </Card.Body>
        </Card>

        <Card
          text="dark"
          bg={lockingID === introID ? "warning" : null}
          className="toc_list_card"
        >
          <Card.Header style={this.headerStyle}>
            <span className="toc_order_number">Intro</span>
            <Button
              variant={lockingID === introID ? "primary" : "secondary"}
              size="sm"
              className="toc_delete_btn"
              onClick={() => this.lockClicked("INTRO")}
            >
              <span className="fa fa-lock" />
            </Button>
            <Button
              variant="danger"
              size="sm"
              className="toc_delete_btn"
              onClick={() => this.deleteClicked("INTRO")}
            >
              <span className="fa fa-eraser" />
            </Button>
          </Card.Header>
          <Card.Body style={this.bodyStyle}>
            <Row>
              <Col>
                <Form.Control
                  style={{ height: "100px" }}
                  as="textarea"
                  size="sm"
                  type="text"
                  placeholder="Intro"
                  onFocus={this.focus}
                  //onBlur={this.blur}
                  value={intro}
                  onChange={this.onIntroChange}
                />
              </Col>
            </Row>
          </Card.Body>
        </Card>

        <Card
          text="dark"
          bg={lockingID === mainImgID ? "warning" : null}
          className="toc_list_card"
        >
          <Card.Header style={this.headerStyle}>
            <span className="toc_order_number">Main Image</span>
            <Button
              variant={lockingID === mainImgID ? "primary" : "secondary"}
              size="sm"
              className="toc_delete_btn"
              onClick={() => this.lockClicked("MAIN_IMG")}
            >
              <span className="fa fa-lock" />
            </Button>
            <Button
              variant="danger"
              size="sm"
              className="toc_delete_btn"
              onClick={() => this.deleteClicked("MAIN_IMG")}
            >
              <span className="fa fa-eraser" />
            </Button>
          </Card.Header>
          <Card.Body style={this.bodyStyle}>
            <Row>
              <Col>
                <Image src={mainImgUri} style={{ maxWidth: "100%" }} />
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </div>
    );
  }
}

const mapState = state => {
  const { editArticlePanel } = state;
  const { metaEditHistory, lockingID } = editArticlePanel;

  const metaDict = metaEditHistory[metaEditHistory.length - 1];

  return {
    metaDict,
    lockingID
  };
};

const mapDispatch = {
  snapShotEditArticleMetaAction,
  recoverLastEditArticleMetaAction,
  updateArticleMetaTextAction,
  updateArticleMetaContributorNamesAction,
  setLockingIDAction,
  setACDItemAction,
  pushContributorNameAction,
  deleteContributorNameAction,
  saveArticleAction
};

export default connect(
  mapState,
  mapDispatch
)(EditArticleMetaList);
